import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { IThumbnailProvider } from '@3ddv/software-division-components';
import { DvmService } from './dvm.service';
import { PopoverDataTransformerService } from './popover-data-transformer.service';

@Injectable({
  providedIn: 'root',
})
export class GroupSalesThumbnailProviderService implements IThumbnailProvider {
  private dvmService = inject(DvmService);
  private dataTransformer = inject(PopoverDataTransformerService);
  private loaded = new Map<string, string>();

  peekThumbnail(nodeId: string): string | undefined {
    return this.loaded.get(nodeId);
  }

  getThumbnail(nodeId: string): Observable<string> {
    const thumbnailSectionId =
      this.dataTransformer.getThumbnailSectionId(nodeId);

    return this.dvmService.loadThumbnail(thumbnailSectionId).pipe(
      map((img: HTMLImageElement) => img.src),
      tap(url => this.loaded.set(nodeId, url))
    );
  }
}
